import { isMobile } from '@/services/DeviceDetectorService';

export interface DeviceState {
  mobile: boolean;
}

export const DeviceModule = {
  state: {
    mobile: isMobile(),
  },
  mutations: {
    refreshDeviceMode(state: any, flag: boolean) {
      state.mobile = isMobile();
      return state;
    },
  },
};
